export default {
    sysTitle: "Merchant Platform",
    operatorId: "Operator code",
    oprName: "Name of operator",
    tips: "Tips",
    isDelete: "Are You Sure You Want to Delete",
    deleteSuccess: "Successfully Deleted",
    updateSuccess: "Successfully Update",
    addSuccess: "Add Successfully",
    all: "All",
    operation: "Operation",
    dl: "quantity of electricity",
    eleFee: "Electricity fees",
    serverFee: "Service fees",
    delayFee: "Delay fee",
    totalAmount: "Total amount",
    yuan: "yuan",
    kWh: "kWh",
    unitOrder: "single",
    ac: "AC",
    dc: "DC",
    confirm: "confirm",
    noData: "No data",
    allCity: "All cities",
    chargingStation: "Charging station",
    merchant: "Merchant",
    operator: "Operator",
    chargingPile: "Charging pile",
    year: "Year",
    month: "Month",
    day: "Day",
    yesterday: "yesterday",
    today: "today",
    thisMonth: "This month",
    thisYear: "This year",
    allday: "all",
    timeType: "Time type",
    regularText: "Regular",
    irregular: "Irregular",
    operationSucess: "operation Sucess",
    saveSucess: "Successfully Save",
    exportSuccess: "Import succeeded",
    allSelect: "All Select",
    toExamine: "To examine",
    invalid: "Invalid",
    check: "Check",
    invoicing: "Invoicing",
    agree: "Agree",
    refuse: "Refuse",
    multipleChoice: "Header Settings",
    exportEdit: "export edit",
    edit: "edit",
    loading: "loading...",
    outText: "Login expired, please login again",
    browse: "browse",
    //单位
    unitText: {
        pen: "pen",
        yuan: "yuan",
        hours: "hours",
        people: "people",
        seat: "seat",
        wan: "w",
        wyuan: "w yuan",
        wkWh: "w kWh",
        wkW: "w kW",
        year: "year",
        month: "month",
        day: "day",
        ton: "ton",
        second: "second",
        full: "full",
        reduce: "reduce",
        give: "give",
        zhang: "zhang",
        individual: "individual",
        xHours: "hours",
        minute: "minute",
        seconds: "second",
        noDiscount: "No discount",
        hold: "hold",
        set: "set",
        total: "total",
        days: "day",
    },
    formText: {
        startTime: "startTime",
        endTime: "endTime",
        export: "export",
        exportLoading: "loading...",
        exportNumber: "Number of exports",
        exportPl: "The number of exports cannot be less than or equal to 0",
        exportError: "Export error or timeout",
        allCity: "all city",
        selectGun: "Charging gun",
        selectMch: "Merchant",
        selectSite: "Charging station",
        selectPile: "Charging pile",
        selectTime: "Choose the time",
        selectTimePl: "Please select the time",
        selectOper: "Operators",
        downloadForm: "Download form",
        intTips: "number",
        beginTimeTips: "Please select start time",
        endTimeTips: "Please select end time",
        import: "Import",
        selectProvince: "Please select Province",
        selectCity: "Please select a city",
        selectArea: "Please select area",
        subSuccess: "Operation successful",
        goBack: "Go back",
        timeNull: "Please select a time",
        timeMax: "The start time cannot exceed the end time",
    },
    // 验证
    regular: {
        name: "name",
        please: "Please input",
        max: "No more than",
        maxText: "characters",
        min: "Not less than",
        numberABC: "It can only consist of numbers or letters",
        numberABCs: "It can only be composed of numbers, letters and underscores",
        tel: "Please enter the mobile number or the phone number, 7-15 digits",
        phone: "Please enter the phone number",
        phonePl: "Please input mobile phone number",
        phonePl11: "Please enter the 11 digit mobile phone number",
        phoneError: "Please input the correct mobile phone number",
        int: "It can only be an integer number",
        maxInput: "Maximum input",
        minInput: "Minimum input",
        unit: "",
        maxNum: "Cannot be greater than",
        minNum: "Cannot be less than",
        money: "amount of money",
        towDecimal: "Keep up to two decimal places",
        email: "Please input email",
        emailPl: "Mailbox cannot exceed",
        emailError: "Please fill in the correct email",
        passwordPl: "Please input a password",
        passwordError: "The password must contain letters and numbers and be between 8 and 16 in length. Please re-enter",
    },
    directCurrent: "DC",
    alternatingCurrent: "AC",
    gunStatus: "gun status",
    gunStatusObj: {
        onLine: "on line",
        offLine: "off line",
        free: "free",
        connected: "connected",
        charging: "charging",
        full: "full",
        trouble: "trouble",
        disabled: "disabled",
        booked: "booked",
    },
    //===========================按钮===========================
    search: "search",
    update: "update",
    add: "add",
    delete: "delete",
    close: "Close",
    save: "Save",
    refresh: "Refresh",
    back: "go back",
    export: "export",
    import: "import",
    submit: "submit",
    cancel: "cancel",
    details: "details",
    determine: "determine",
    //===========================按钮===========================
    // 登录
    login: {
        contentTitle: "Charging for a better life",
        contentTitleSmall: "Access to the open platform, and the interconnection ecology is clear at a glance",
        account: "Account login",
        userNamePl: "enter one user name",
        passwordPl: "Please input a password",
        passwordMax: "Please enter a password with more than 6 digits",
        userName: "user name",
        password: "password",
        login: "login",
        accountTime: "After",
        accountTime2: "days, the account will become invalid and you will not be able to log in to the system",
        mchSys: "Merchant system",
        changeLangPl: "Please select a language",
    },
    home: {
        assetTitle: "Asset information",
        staCount: "Charging station",
        pileCount: "Charging pile",
        gunCount: "Charging muzzle",
        totalPower: "Total power(kW)",
        chargeEcharTitle: "Charging and income",
        chargeEcharTypeDay: "(Nearly 30 days, excluding today)",
        chargeEcharTypeMonth: "(Last December)",
        chargeEcharTypeYear: "(Last 10 years)",
        feeYAxisName: "cost",
        map: "Charging map",
        gunTotal: "Total number of guns",
        dataStatistics: "Charging data statistics",
        chargeDl: "Charging capacity(kW·h)",
        totalTransAmount: "Charging amount",
        chargeTimes: "charging cycles",
        useRate: "Usage rate",
        mchIncomeAmount: "Income amount",
        avgChargeTimes: "Average charging",
        monthAvgUseRate: "Site usage rate this month",
        totalIncomeAmount: "Income amount",
        mchPayAmount: "Expenditure amount",
        gunStatus: "Charging gun status",
        rankingTitle: "Site Ranking",
        rankingTitleDl: "Quantity of electricity",
        rankingTitleMoney: "Amount",
        rankingNo: "No ranking",
        mapStaStutas: "Site status",
        mapAc: "AC",
        mapDc: "DC",
        mapQuery: "Query",
        mapStaTel: "Site phone",
        todayOrder: "Order volume today",
        todayDl: "Charge today",
        todayRevenue: "Today's revenue",
        yesterdayOrder: "Yesterday's order trend",
        todayDlTime: "Charging capacity (KWH) from 00:00 to 24:00 today",
        todayOrderTime: "Order quantity (order) created today from 00:00 to 24:00",
        siteNum: "Site Statistics",
        pileNum: "Site",
        gunNum: "Muzzle",
        dcNum: "DC port",
        acNum: "AC port",
        dcPower: "DC pile power",
        acPower: "AC pile power",
        settlementTitle: "Settlement information",
        dailyDtatement: "Unsettled daily statement",
        withdrawalForm: "Unpaid withdrawal document",
        undrawnAmount: "Amount being paid",
        withdrawnAmount: "Amount paid",
        revenueTitle: "Revenue statistics",
        totalRevenue: "Total income",
        onlineChargingSharing: "Online charging share",
        offlineChargingSharing: "Offline charging income",
        yesterdayRanking: "Top utilization of equipment yesterday",
        pile: "Electric pile",
        utilizationRate: "Utilization rate",
        order: "Order (pen)",
        total: "total",
        hour: "hour",
    },
    // 主页地图
    homeMap: {
        search: "Search",
        reset: "Reset",
        area: "Area",
        power: "Power",
        quantity: "Quantity",
        tower: "Tower",
        merchant: "Merchant",
        deviceType: "Device Type",
        staSize: "Charging station scale",
        netDirection: "Interconnection",
        staStatus: "Operational status",
        staActivity: "Site Activity",
        normalSearch: "Normal Search",
        advancedSearch: "Advanced Search",
        ac: "AC pile",
        dc: "DC pile",
        smallSize: "small-scale",
        mediumSize: "Medium scale",
        largeSize: "large-scale",
        yes: "Yes",
        no: "No",
        site: "Site",
        pile: "Pile",
        screenPl: "Please enter the charging station and operator",
        screenResult: "Find relevant results for you about",
        moreSelect: "checkbox",
        more: "more",
        notOpened: "Not opened",
    },
    //非实名卡管理
    nonCard: {
        cardMember: "Electric card member",
        cardMemberStatis: "Card member status",
        use: "in use",
        logOff: "Logged off",
        recharged: "Recharged this year",
        charged: "Charged this year",
        globalSearch: "Serial number/phone number/contact person/phone number",
        cardStatis: "Card status",
        activation: "activation",
        normal: "normal",
        logOffBtn: "log off",
        rechargedBtn: "recharged",
        refundBtn: "refund",
        operationRecord: "Operation record",
        capitalRecord: "Fund record",
        thisYear: "this year",
        accountPkId: "membership card",
        cardPhysicalNumber: "Card serial number",
        cardSerialNumber: "Serial number",
        silkScreenNumber: "Silk screen number",
        contactName: "contacts",
        phoneNo: "phone",
        accountBalance: "Card balance",
        cardStatus: "Card status",
        createTime: "Card opening time",
        cardPkId: "Card number",
        remarks: "remark",
        rechargeAmount: "Recharge amount",
    },
    nonFundHistory: {
        rechargedTab: "recharged",
        chargedTab: "charged",
        refundTab: "refund",
        staName: "Site name",
        chargeBeginTime: "start time",
        chargeEndTime: "end time",
        chargeMinutes: "Charging time",
        chargeElect: "Charging capacity(kWh)",
        delayAmount: "Delay fee",
        delayDuration: "Delay duration",
        chargeAmount: "Charging amount",
        beforeBalance: "Balance before transaction",
        afterBalance: "Post transaction balance",
        orderNo: "order number",
        transactionTime: "Recharge time",
        rechargeAmount: "amount",
        createName: "Operator",
        refundTime: "Refund time",
        refundAmount: "refund amount",
        refundedAmount: "Successful refund amount",
        refundResultDesc: "Refund progress",
        time: "time",
    },
    // 注销卡
    cancellation: {
        cardSerialNumber: "Serial number",
        accountBalance: "account",
        tips: "After cancellation, the amount in the card will be automatically refunded in full, and the charging card will not be used",
        success: "Logout successful",
        successConfirm: "Are you sure you want to sign out?",
    },
    // 卡详情
    nonCardDetails: {
        cardInfo: "Electric card information",
        remark: "remark",
        accountBalance: "Account balance",
        createUserName: "Card opener",
        createTime: "Card opening time",
        statusDesc: "Electric card status",
    },
    //非实名在线卡
    nonRealNameCardManagement: {
        cardMember: "card member",
        cardStatus: "card status",
        inUse: "in use",
        cancelled: "cancelled",
        operationStatistics: "operation statistics",
        selfSupport: "self support",
        generationCamp: "generation camp",
        fuzzySearch: "fuzzy search",
        cardAffiliation: "card affiliation",
        commercialTenant: "commercial tenant",
        cardNumber: "card number",
        cardPhysicalNumber: "card physical number",
        cardSerialNumber: "card serial number",
        contacts: "contacts",
        phone: "phone",
        cardBalance: "card balance",
        frozenAmount: "frozen amount",
        openTime: "open time",
        remark: "remark",
        money: "Card opening amount",
        openCardTips: "Please keep the card holder connected to the computer and place the card on the card holder",
        openCardError: "The charging card has been used! Please change the card",
        cardPhysicalNumberPl: "Please input the serial number of the card",
        cardSerialNumberPl: "Please enter the serial number",
        moneyPl: "Please enter the recharge amount",
        moneyMax: "One time recharge amount cannot be more than 5000",
        moneyMin: "One time recharge amount cannot be less than 0",
        moneyError: "The card opening amount must be in number and not more than two decimal places",
        openCardSuccess: "Card opened successfully",
        balance: "balance",
        amount: "amount of money",
        cancellation: "cancellation",
        cancellationTips: "After cancellation, the amount in the card will be automatically refunded in full, and the charging card will not be used",
        cancellationSuccess: "Logout succeeded",
        accountBalance: "Account balance (yuan)",
        createUserName: "Card opener",
        createTime: "Opening time",
        status: "Card status",
        operationInfo: "Operation information",
        cardInfo: "Card information",
        cardDetails: "Non real name card details",
        remarkPl: "Please enter your comments",
        createName: "Operator",
        operateTime: "Operation time",
        operateType: "Operation",
        rechargeAmount: "Recharge amount (yuan)",
        allMoneyMax: "The maximum amount of online card cannot exceed 9999 yuan",
        accountPkId: "Membership card number",
        refundAmount: "Refund amount (yuan)",
        refundBtn: "Refund",
        refundError: "The refund amount cannot exceed the account balance",
        refundSuccess: "Refund successful",
        silkScreenNumber: "Silk screen number",
        getCard: "card reading",
        input: "Direct entry",
        reset: "Reset",
        cardExist: "The card already exists. Please log off or change a card before opening it",
        openCard: "activate a bank card",
        silkScreenNumberPl: "Please enter the silk screen number",
        contactsPl: "Please enter contact",
        cardYes: "This card is operational",
        logout: "Logout",
        viewNo: "Your browser does not support card issuing system",
        connectError: "Issuer connection failed",
        logoutSuccess: "Card cancellation succeeded",
        cardChange: "The card has been replaced, please read the card again",
        cardWhite: "This card is blank. Please open it first",
        statusError1: "Please read the card before operation",
        statusError2: "No charging card detected, please operate again",
        statusError3: "Customer code cannot be empty",
        statusError4: "Card type cannot be empty",
        statusError5: "ID cannot be empty",
        statusError6: "Card ID can only be 16 digits",
        statusError7: "Not this system card, unable to operate!",
        logoutTitle: "This operation destroys all the information of this card. Please be careful",
        connectBtn: "Connect card issuer",
        connectBtnLoading: "Connecting card issuer……",
        cardBind: "Some cards have been used. Please change an unused card,Serial number: ",
        relation: "Relation",
        userName: "Member name",
        cardNumberPl: "Please enter the card number",
        relationSuccess: "Association succeeded",
        hasSms: "Send SMS",
        hasSmsPl: "Please select whether to send SMS",
        word: "Warm tips: operating instructions",
        wordDownload: "Click here to download",
        no: "no",
        yes: "yes",
        cardConnectionFailed: "Card issuer connection failed",
        notSupport: "Your browser does not support the card issuing system",
    },
    // 发卡下载提示
    cardTips: {
        t1: "1.Download and install the card issuer driver",
        download: "Click here to download",
        t1_1: "XP system, please",
        t2: "2.Connect the card reader to the computer through the USB cable. After normal power on, the card reader will 'beep' and keep the LED inside the card reader flashing.",
        t3: "3.Download and run the card issuer plug-in(",
        t3_1: "), after connecting the card reader, click 'open service'.",
        t4: "4.Open the card issuing management of the browser for relevant operations.",
        tips: "matters needing attention:",
        tips1: "1.At present, it supports windows operating system and windows 7 / 10 series versions.",
        tips1_1: "If you want to use it under Windows XP, you need to install the. NET3.5 framework",
        tips2: "2.During operation, ensure that the card issuer plug-in is in continuous service status.",
        tips3: '3.When the prompt "check whether to insert a card reader or install a serial port driver" is prompted, it is generally a problem that the card reader is not inserted or the serial port driver is not installed. Right click "my computer" and select "management", and then in the pop-up "computer management" window, click "device manager" in the left menu, Check whether "USB serial port" or "ft232rusr UART" exists under "other devices". If not, it means that the card reader is not plugged in. Try another USB oral test;',
    },
    // 商户信息
    addMerchant: {
        info: "essential information",
        fullName: "Merchant name",
        shortName: "Merchant abbreviation",
        contacts: "contacts",
        contactsMail: "Contact email",
        telephone: "contact number",
        address: "Contact address",
        operatorShare: "Operator share",
        shareType: "Classification",
        isMoneyRules: "Fixed amount",
        isMoneyRulesShareMaxError: "Fixed amount share cannot be greater than total amount, please check",
        orderTotalMoney: "Total amount of single order",
        orderTotalMoneyMax: "More than RMB",
        orderShare: "Share of each order",
        isMoneyRulesTips: "Display the corresponding allocation amount according to the classification type, multiple choices. Note: after the fixed amount is selected, the total amount cannot be selected again for each order of percentage type",
        isPercentageRules: "percentage",
        order: "Every order",
        cashConfig: "Withdrawal allocation",
        cashMin: "Minimum withdrawal amount",
        condition: "condition",
        fromValueTips: "Full settlement amount",
        feeTips: "Deduction of transfer charges",
        feeTipsPl: "Percentage of transfer fee deducted",
        loginUrl: "Login address",
        addTitle: "New account number",
        resetPassword: "reset password",
        mchCollectionInfo: "Merchant Collection Information",
        bankAccountName: "Bank account name",
        bankDeposit: "Opening bank of collection account",
        bankAccountNo: "Receiving bank account",
        addMch: "New merchant",
        loginTitle: "New login account",
        updataTitle: "Modify login account",
        required: "Required",
        textLenMax: "Length cannot exceed",
        divisionPercentPl: "Please choose the way of sharing",
        divisionPercentMax: "Value range: 0.00 ~ 100",
        divisionPercentError: "Please enter a valid number",
        base2: "percentage",
        minWithdrawAmount: "Minimum withdrawal amount",
        bankDepositPl: "Please enter the name of the collection account",
        bankAccountNamePl: "Please enter the name of the collection account",
        userName: "Login user name",
        effectiveTime: "entry-into-force time",
        expireTime: "Expiration time",
        accountName: "title of account",
        bankInstitutionDesc: "banking institution",
        remarks: "remarks",
        delConfig: "Are you sure you want to delete the current account",
        userParamsNull: "Login user account cannot be empty",
        isPercentageRulesPl: "Please select the type of percentage",
        isPercentageRulesError: "The type of percentage cannot be repeated",
        addSuccess: "Added successfully",
        mchLoginInfo: "Merchant login information",
        userParamsMax: "There can only be one login user, please delete the redundant one",
        mchDetails: "Merchant details",
        upDetails: "Modify merchant",
        add: "add",
        rolePkIdPl: "Please select a role",
        expireTimePl: "Please select the effective date first",
        expireTimeError: "Cannot be less than effective date",
        userNameError: "repeat of user name",
        issueCardCode: "Customer code",
        userPwd: "password",
        confirmPassword: "confirm password",
        amountType: "Electricity charge per order",
        amountType2: "Service charge per order",
        amountType3: "Delay fee per order",
        cooperationTime: "Cooperation deadline",
        fixedShare: "Fixed share",
        fixedShareText: "Divided by kWh",
        invoiceSet: "Invoice Setting Information",
        invoiceType: "Invoice Type",
        hasOpenAudit: "Enable invoice review",
        open: "open",
        close: "close",
        wxMerchantName: "WeChat Collection Merchant Name",
        wxMerchantAccount: "WeChat collection merchant account",
        settlementType: "Classification Rule Type",
        onLine: "On-line",
        offline: "Offline",
    },
    // 修改操作密码
    upSafePassword: {
        userPwd: "New password",
        confirmPassword: "Repeat new password",
        verCode: "Mobile phone verification code",
        verCodePl: "Verification code cannot be empty",
        userPwdPl: "Password cannot be empty",
        userPwdLen: "Password length 6-18",
        userPwdError: "The password cannot contain spaces, tabs, and newlines",
        confirmPasswordPl: "Confirm password cannot be empty",
        confirmPasswordError: "Please confirm whether the new and old passwords are consistent",
        upError: "Modification failed",
        upSuccess: "Password changed successfully, please log in again",
    },
    // 共用名称（订单列表也在里面）
    commonTableName: {
        insideOrderNo: "Internal order ",
        externalOrderNo: "External order",
        orderStatus: "Order status",
        orderType: "Order type",
        no: "no",
        yes: "yes",
        details: "details",
        endOrder: "Close order",
        error: "exception handling",
        orderNo: "order number",
        merchantName: "Merchant name",
        netSystemName: "Internet operators",
        staName: "Charging station",
        pileName: "Pile name",
        gunName: "Gun name",
        serialNumber: "Serial number",
        memberName: "Member name",
        phoneNo: "phone",
        carNo: "license plate",
        chargeBeginTime: "Start charging time",
        chargeEndTime: "End charging time",
        payTime: "Payment time",
        chargeDuration: "Charging time",
        delayDuration: "Time of pile occupation",
        chargeElect: "Quantity of electricity(kWh)",
        chargeAmount: "electricity fees(yuan)",
        serviceAmount: "Service fees",
        delayAmount: "Delay fee",
        totalAmount: "Total amount(yuan)",
        discountAmount: "discount amount",
        transactionAmount: "transaction Amount",
        startSoc: "start soc",
        endSoc: "end soc",
        stopReason: "stop reasonDesc",
        orderSource: "Order source",
        abnormalType: "abnormal type",
        elecPrice: "Electricity rete(yuan/kWh)",
        servicePrice: "Servic rate(yuan/kWh)",
        slotFlag: "Electricity fee type",
        slotElecPrice: "Electricity price(yuan)",
        time: "Time",
        delayMins: "Time(minute)",
        delayFreeMins: "Free time(minute)",
        delayFree: "Free time",
        sex: "Sex",
        vipType: "Member type",
        vin: "VIN",
        cardType: "Car model",
        staType: "Site type",
        staStatus: "Site status",
        staAddr: "Site address",
        gunPkId: "gun id",
        manufacturer: "Belong to manufacturer",
        deviceType: "Pile type",
        devicemodel: "Equipment model",
        ratedPower: "Rated power",
        ratedCurrent: "Rated current",
        ratedVoltage: "Rated voltage",
        timeInterval: "time interval",
        chargeDiscount: "Electricity discount",
        serviceDiscount: "Dervice discount",
        delayDiscount: "Delay discount",
        totalDiscount: "Total discount amount",
        chargeTransAmount: "Paid in tariff",
        serviceTransAmount: "Paid in service fee",
        jian: "sharp",
        feng: "peak",
        ping: "flat",
        gu: "valley",
        beforeBalance: "Amount before(yuan)",
        afterBalance: "Amount after(yuan)",
        reteInfo: "Rate information",
        charge: "Charging times(second)",
        startTime: "Start time",
        endTime: "End time",
        modifyTime: "Modify time",
        staPkId: "Site number",
        entUserName: "Enterprise name",
        chargingCard: "User card number",
        chargingMode: "charging mode",
        userType: "user type",
        consumptionPattern: "Charging mode",
        startMode: "start mode",
        vipLevel: "Member level",
    },
    // 订单列表页面
    orderList: {
        orderSource1: "Online order",
        orderSource2: "Offline order",
        exportType: "default",
        exportType2: "details",
        end: "Charge is over",
        endConfirm: "Are you sure you want to close the order?",
        endLoadingTips: "Issue stop charging command",
        endLoadingTips2: 'The system will issue the stop charge command to the charging pile. If the order status cannot be changed to "charging completed" within 15s, the second step operation will continue',
        endLoadingTips3: "Generate platform Charging Report",
        endLoadingTips4: 'The system will push the platform charging report to the charging pile. If the order status cannot be changed to "charging completed" within 15s, the third step will continue',
        endLoadingTips5: "Modify order status to abnormal order",
        endLoadingTips6: "The system will modify this order as an abnormal order, and the user can normally perform the next charging operation",
        endLoading: "In process..",
        endCharge: "End charging",
        loadingSuccess: "The stop command is issued successfully",
        success: "Platform report generated successfully",
        orderError: "Order status changed to exception",
        endSuccess: "End success",
        pageTitle: "Charging order",
        totalChargeElect: "Total charge(kWh)",
        totalTransactionAmount: "Total Actual Revenue",
        totalServiceAmount: "Service charge",
        totalChargeAmount: "Electricity fees",
        totalDelayAmount: "Delay fee",
        totalDiscount: "Total amount discount",
        totalServiceDiscount: "Service fee discount",
        totalChargeDiscount: "Electricity discount",
    },
    // 订单异常结算页面
    abnormalOrder: {
        pileCharging: "Pile charge",
        chargeTime: "Charging period",
        stopReason: "Stop reason",
        pileChargeAmount: "Total charge charge (yuan)",
        sysCharging: "Platform billing",
        sysChargeAmount: "Total platform charging fee (yuan)",
        pileErrorValue: "Error between pile and pile",
        normalErrorValue: "Normal error: the difference is less than 0.5 yuan or the difference proportion is less than 20%",
        usePileCharging: "Charge by using pile",
        useSysCharging: "Charging by using platform",
        countType: "Calculation formula: total pile charging fee / total platform charging fee + total delay fee",
        payAmount: "Total payment",
    },
    //订单详情
    orderDetails: {
        aorderDetailsTitle: "Charging order details",
        userSiteTabTitle: "User and site information",
        chargeType: "Charging type",
        chargeStatus: "Charging state",
        chargingModel: "Charging strategy",
        chargeElect: "Charging capacity",
        chargeDuration: "Charging time",
        orderCheckDetails: "Order verification details",
        chargeDataEchart: "Charging data",
        chargeMoneyEchart: "Charging charge data curve",
        batteryEchart: "Battery information curve",
        pileSignal: "Pile signal",
        faultCode: "Exception code",
        faultName: "Exception name",
        faultDesc: "Exception description",
        userInfo: "User info",
        siteInfo: "Site information",
        siteId: "Site id",
        pileInfo: "Pile information",
        rateInfo: "Fee information",
        errorHandle: "exception handling",
        billingMethod: "Billing method",
        operationTime: "Operation time",
        operationoOject: "Operation object",
        pileCreationTime: "Equipment commissioning time",
        chargeFeeYLeftName: "Cost (yuan)",
        chargeFeeYRightName: "Electricity(kW/h)",
        chargeTemperatureYLeftName: "temperature",
        chargeTemperatureYRightName: "voltage",
        insertGun: "Insert a gun",
        startCharging: "Start charging",
        endCharging: "End charging",
        draw: "Draw",
        outputVoltage: "output voltage",
        chargingPower: "charging power",
        outputCurrent: "output current",
        demandVoltage: "demand voltage",
        demandCurrent: "demand current",
        cpVoltage: "CP voltage",
        chargerTemperature: "charger temperature",
        gunTemperature: "gun temperature",
        brmProtocol: "BRM protocol version",
        brmBatteryType: "BRM battery type",
        brmBatteryCapacity: "BRM battery rated capacity",
        brmRatedVoltage: "BRM rated total voltage",
        BCPMaxVoltage: "Maximum voltage of BCP unit",
        BCPMaxCurrent: "BCP maximum current",
        BCPBatteryEnergy: "Total energy of BCP battery",
        BCPMacVoltage: "BCP maximum charging voltage",
        BCPMaxTemperature: "BCP maximum temperature",
        BCPStartSOC: "BCP starts SOC",
        BSMMaxTemperature: "BSM maximum power battery temperature",
        BCSMaxBatteryVoltage: "BCS maximum cell voltage",
        // 结算信息
        settlementTableName: "project",
        settlementTablePayableAmount: "Payable (yuan)",
        settlementTableDiscountAmount: "Discount (yuan)",
        settlementTabletransAmount: "Actual payment (yuan)",
        settlementTabletransDl: "electric charge",
        settlementTabletransServer: "service charge",
        settlementTabletransDelay: "delay charge",
        retaInfoTab1: "Settlement information",
        retaInfoTab2: "Charging charge information",
        retaInfoTab3: "Delay fee information",
        retaInfoTab4: "VIP/coupon information",
        total: "total",
        vipDiscount: "VIP discount",
        couponDiscount: "Coupon discount",
        serviceAmount: "Service fee payable",
        serviceDiscount: "Preferential service fee",
        vipDiscountAmount: "VIP discount",
        couponDiscountAmount: "coupon",
        serviceTransAmount: "Paid service fee",
        chargeAmount: "Electricity charges payable",
        chargeDiscount: "Preferential electricity charge",
        chargeTransAmount: "Paid electricity charge",
        delayAmount: "Delay fee payable",
        delayDiscount: "Discount for delay fee",
        delayTransAmount: "Paid delay fee",
        totalAmount: "Total",
        totalDiscount: "Total amount discount",
        transactionAmount: "Total paid",
        discountTotal: "Total discount",
        discountName1: "Event",
        discountName2: "Enterprise preference",
        discountName3: "Interface user preference",
        discountName4: "Interconnection",
        discountName5: "Non real name card",
        typeName1: "Activity",
        typeName2: "enterprise",
        typeName3: "interconnection",
        typeName4: "interface user cost",
        typeName5: "Non real name card",
        //费率表格
        dlInfo: "Electricity information",
        slotFlagDesc: "Type of electricity",
        time: "Power use period",
        electricity: "Electricity（kWh）",
        standardExpenses: "Standard expenses",
        slotServicePrice: "Service rate(yuan/kWh)",
        slotElecPrice: "Electricity rate(yuan/kWh)",
        discountServiceAmount: "Service fee discount(yuan)",
        discountElectAmount: "Electricity discount(yuan)",
        cost: "Activity/enterprise/interconnection/interface user cost",
        delayCost: "enterprise/interconnection/interface user cost",
        delayInfo: "Delay information",
        minutesOhter: "Delay duration (min)",
        slotDelayPrice: "Rate (yuan/minute)",
        delayFee: "Delay fee payable(yuan/minute)",
        // slotDelayPriceOhter: "Delay fee rate（yuan/minute）",
        // totalAmountOhter: "Delay fee payable(yuan)",
        discountAmountOhter: "Discount for delay fee(yuan)",
        discountType: "Discount type",
        vipTotalDiscount: "Total discount",
        discount: "discount",
    },
    // 离线卡订单
    offCardOrder: {
        cardPhysicalSn: "Serial number",
        cardSn: "Physical card number",
        chargeMode: "Charging mode",
        dealType: "Order status",
        exportName: "Offline card order",
        dl: "Charging capacity(kWh)",
        amount: "Income amount(yuan)",
        service: "Service charge(yuan)",
        chargingTime: "Charging time",
        orderNumber: "Order quantity(pen)",
        offCardNum: "Number of offline cards",
        chargingType: "Charging mode",
    },
    // 离线卡详情
    offCardOrderDetails: {
        pageTitle: "Charging order details",
    },
    //运营数据
    operationData: {
        revenueTitle: "Revenue statistics",
        revenueTime: "Statistical payment time",
        totalTransAmount: "Total revenue statistics",
        totalTransServiceAmount: "service charge",
        totalTransElecAmount: "electric charge",
        totalTransDelayAmount: "Delay fee",
        proportion: "Total income",
        settlementInfo: "Settlement information",
        unsettledOrderNum: "Unsettled daily statement",
        notPaidDrawCashOrderNum: "Unpaid withdrawal note",
        undrawAmount: "Undrawn amount",
        inPayAmount: "Withdrawing amount",
        drawedAmount: "Withdrawn amount",
        serviceCharges: "Accumulated withdrawal fee",
        orderTitle: "Order statistics",
        chargeOrderCount: "Charging order",
        reservationOrderCount: "Appointment order",
        offlineOrderCount: "Offline Card Orders",
    },
    //事件告警
    alarmEvent: {
        alarmTime: "alarm time",
        eventAmount: "event amount",
        todayEvent: "today event",
        alarmRatio: "alarm ratio",
        alarmLevel: "alarm level",
        alarmType: "alarm type",
        equipmentAlarmAmountTop5: "equipment alarm amount top5",
        stationAlarmAmountTop5: "station alarm amount top5",
        equipmentSn: "equipment sn",
        stationName: "station name",
        quantity: "quantity",
        faultDesc: "fault desc",
        recoverTime: "recover time",
        duration: "duration",
        alarmStatus: "alarm status",
        equipmentType: "equipment type",
    },
    //站点监控
    siteMonitor: {
        province: "province",
        city: "city",
        type: "type",
        power: "power",
        equipmentAmount: "equipment amount",
        gun: "gun",
        number: "number",
        voltage: "voltage",
        current: "current",
        chargeElect: "Electricity",
        totalPower: "Cumulative charge",
        thisPower: "Current output power",
        setPower: "Set output power",
        totalTimes: "Cumulative charging times (Times)",
        totalHours: "Accumulated charge time",
        accountPkId: "Charging account number",
        accountType: "Account type",
        carVin: "Vehicle VIN",
        chargedMinutes: "Charging time",
        chargingPower: "Charging capacity",
        predictAmount: "Charge amount",
        faultInfo: "Fault information",
        orderDetails: "order details",
    },
    //站点信息
    pileInfo: {
        operationType: "Operation type",
        staStatus: "Operation status",
        pileList: "Pile list",
    },
    // 站点详情
    pileInfoDetail: {
        city: "City",
        staAddress: "Address",
        position: "Construction site",
        staLat: "Latitude and longitude",
        staTypeName: "Site type",
        fullName: "Associated merchants",
        tagInfoVos: "Site Tags",
        commissioningDate: "Operation time",
        businessBeginHours: "Opening Hours",
        parkNum: "Number of parking spaces",
        serviceTel: "Service telephone",
        phoneNo: "Site phone",
        hasFreePark: "Free parking fee or not",
        yes: "Yes",
        no: "No",
        remarks: "Reminder",
        feeName: "Site rate",
        DC: "DC pile",
        AC: "AC pile",
        oprDelayFeeInfos: "Delay fee",
        delayFreeMinutes: "Free duration",
        staPics: "Site image",
        staInfo: "Charging point information",
        totalDev: "Total equipment",
        dcGunCount: "Direct current muzzle",
        acGunCount: "Exchange muzzle",
        tab1: "Site details",
        tab2: "Maintenance/Rate Change Record",
        price: "Total price(yuan/kWh)",
        manufacturerName: "Equipment manufacturer",
        ratedPower: "Rated power(kW)",
        delayUnit: "yuan/minute",
        reason: "reason",
        debuggingPeople: "Debugging personnel",
        debuggingContent: "Debugging content",
        oldFeeName: "Old rate",
        newFeeName: "New rate",
        replaceTime: "Replacement date",
    },
    // 站点电价列表
    pileInfoEle: {
        addRateBtn: "Add rate template",
        upRateBtn: "Change rate template",
        delRateBtn: "Delete rate template",
        rateTpl: "Rate template",
        feeName: "Template name",
        feeNamePl: "Please enter a template name",
        acRate: "AC pile rate",
        dcRate: "DC pile rate",
        delayRate: "Delay rate",
        delayFreeMinutes: "Free time (minutes)",
        rate: "Rate",
        elePriceList: "Electricity price list",
        slotFlag: "Electricity price type",
        slotElecPrice: "Electricity price(yuan)",
        slotServicePrice: "Service charge(yuan/kWh)",
        time: "Time slot",
        slotDelayPrice: "rate(yuan/minutes)",
        delRateConfirm: "Are you sure to delete the current electricity price",
        ratePl: "Please select rate",
    },
    // 充电桩信息
    pileList: {
        batchStaBtn: "Batch Association / unbinding",
        batchLineBtn: "Batch go online / go offline",
        addBtn: "Add pile information",
        deviceStatus: "Charging point status",
        showQcode: "QR code",
        editGun: "Editing gun",
        showUnlock: "Unlocking",
        offLine: "off-line",
        showFee: "Issue electricity price",
        outPile: "Move out of charging pile",
        unbind: "Unbundling",
        downQCode: "Issue",
        staName: "Site",
        internalNumber: "Station number",
        chargeGunInfoVoList: "Model of electric gun",
        parkNo: "Parking number",
        gunStatus: "Electric gun status",
        editPile: "Edit pile",
        issueSuccess: "Issue QR code successfully",
        showFeeConfirm: "Is the electricity price determined?",
        showFeeSuccess: "Success of power generation price",
        showUnlockConfirm: "Are you sure to unlock?",
        showUnlockSuccess: "Unlocking succeeded",
        unbindSuccess: "Unbind site successfully!",
        moveInSta: "Charging station moved in",
        moveInStaPl: "Please select charging station",
        remarks: "Remarks",
        gunOperation: "Gun operation",
        updataRecord: "Updata record",
    },
    // 新增桩
    addPile: {
        deviceType: "Equipment type",
        deviceModelPkId: "Equipment model",
        protocolPkId: "Agreement",
        remark: "Remark",
        gunInfo: "Muzzle information",
        info: "Information",
        addName: "Add charging pile",
        staNamePl: "Site must be selected",
        deviceTypePl: "Device type must be selected",
        deviceModelPkIdPl: "Equipment model must be selected",
        sn: "Pile number",
        snPl: "The pile number cannot be empty",
        snPl2: "Pile number must be a number",
        snPl3: "Pile number must be numbers or letters",
        pileNamePl: "Pile name cannot be empty",
        deviceStatusPl: "Operation status cannot be empty",
        protocolPkIdPl: "Please select agreement primary key",
        qrcode: "QR code",
        detailsName: "Charging point details",
        updataName: "Modify charging point",
        charging: "Charging",
        inserted: "Gun inserted",
        fault: "Fault",
        disable: "Disable",
        offLine: "off-line",
        free: "Free",
        full: "Full",
        subscribe: "make an appointment",
        offline: "Offline",
        online: "Online",
        pileCommissioningDate: "Operation time",
        pileCommissioningDatePl: "Please select the commissioning time",
    },
    //分成结算
    splitSettlement: {
        shareSettlement: "Share settlement",
        orderBreakdown: "Order breakdown",
        merchantName: "merchantName",
        chargingOrderNumber: "Charging order number",
        selectionTime: "Select time",
        stationName: "Station name",
        chargeVolume: "Charging volume",
        electricityBill: "Electricity bill",
        serviceCharge: "Service Fee",
        chargeableAmount: "Chargeable amount",
        discountAmount: "Discount amount",
        totalAmountActuallyPaid: "Total paid in amount",
        partitionMethod: "Partition method",
        merchantIncome: "Merchant income",
        operatorShare: "Operator share",
        orderDate: "Order date",
        orderTimeError: "Order time cannot be empty, please select the correct time",
        errorStartTimeEndTime: "The start time cannot be greater than the end time",
        contentConfirm: "Are you sure you want to agree to the selected data? ?",
        successfulOperation: "Successful operation",
        daySettlementOrderNumber: "Day settlement order number",
        dailyStatementStatus: "Daily statement status",
        settlementDate: "Settlement date",
        numberOfOrders: "Number of orders",
        actualChargeAmount: "Actual charge amount",
        merchantIncomeAmount: "Merchant income amount",
        operatorShareAmount: "Operator share amount",
        createTime: "Create time",
        pleaseSelectTheGenerationDate: "Please select the create time",
        createTimeError: "The start time of the generation date cannot be greater than the end time",
        selectMonth: "Please select a monthly closing month",
        confirmDate: "Do you want to confirm the selected data?",
        confirmGeneration: "Confirm to regenerate?",
        withdrawnDate: "Are you sure you want to withdraw the selected data?",
        selectDate: "Do you want to operation the selected data?",
        selectDateToOperate: "Please select the data to be operated",
        deleteTitle: "Reasons for invalidation",
        remarkPl: "Please enter the reason",
        supplement: "Supplement",
        orderNo: "Select daily order number",
        orderNoPl: "Please select order",
        staName: "Charging station",
        settlementStatus: "Accounting status",
        regenerate: "Regenerate",
        allSettlement: "Batch accounting",
        settlement: "accounting",
        errorInfo: "Abnormal information",
        accountingRecords: "Accounting records",
        accountingRecordsStatus: "Accounting status",
        accountingRecordsRepairStatus: "Repair status",
        accountingRecordsTime: "Settlement date",
        initialAccounting: "Initial accounting",
        newAccounting: "Latest accounting",
        ComparisonResults: "Difference of comparison results",
        voidPl: "Please select to void the statement",
        voidSuccess: "The settlement slip was voided successfully",
        auditOrderPl: "Please select the invoice to review",
        auditOrder: "Review statement",
        auditOrderSuccess: "Checking the bill successfully",
        auditOrderConfirm: "It cannot be revoked after review, please operate with caution",
    },
    //商户提现
    withdrawal: {
        dataTitle1: "Cash to be withdrawn",
        dataTitle2: "Withdrawn cash",
        withdrawOrderStatus: "Withdraw order status",
        createTime: "Create time",
        reviewDate: "Review date",
        withdrawOrderTemplate: "Withdrawal order template",
        withdrawOrderNumber: "Withdraw order number",
        withdrawalAmount: "Withdrawal amount",
        transferFee: "Service Charge",
        actualWithdrawalAmount: "Actual withdrawal amount",
        withdrawalAdd: "Add withdrawal form",
        preview: "preview",
        resubmit: "Resubmit",
        withdraw: "withdraw",
        annex: "annex",
        transferAmount: "Actual withdrawal amount",
        completeTime: "Withdrawal completion date",
        orderStatusDesc: "Withdrawal form status",
        withdrawWithdrawal: "Withdrawal form withdrawn",
        withdrawWithdrawalConfirm: "Confirm withdrawal form withdrawal?",
        withdrawWithdrawalSuccess: "Withdrawal order withdrawn successfully",
    },
    // 提现单模板
    withdrawalTemplate: {
        orderNo: "Withdrawal order No",
        order: "Withdrawal form",
        payee: "Payee",
        payer: "Payer",
        remarks: "Remarks",
        remarks1: "1, the amount of charge is charged by the user through the charging station of the operator's official account.",
        remarks2: "2. Actual withdrawal amount = withdrawal amount of current period - transfer service charge;",
        remarks3: "3. The transfer service charge is offline transfer fee;",
        cashExplain: "Withdrawal instructions",
        cashExplain1: "1. After the bill is checked correctly, the applicant shall stamp and confirm it and mail it to the payer's company, or send it by e-mail. The payer will complete the offline public or private transfer within 3-5 working days after receiving.",
        cashExplain2: "2. After signing and sealing, it means that it agrees with the withdrawal and settlement.",
        cashMch: "Withdrawal merchant (seal):",
        sign: "Signature of authorized representative:",
        time: "Date:",
        download: "Download certificate",
        cashInfo: "Withdrawal information",
        merchantName: "Withdrawal merchant",
        staNameList: "Charging station",
        previousBalance: "Balance after withdrawal in previous period",
        totalAmount: "Withdrawal amount in current period",
        serviceCharges: "Transfer charges",
        transferAmount: "Actual cash amount",
        collectionInfo: "Collection information",
        mchContactPerson: "Merchant contact",
        mchPhoneNumber: "Merchant telephone",
        bankAccountName: "Collection account",
        collectionAcc: "Collection account number",
        bankDeposit: "Bank of deposit",
        bankAccountNo: "Collection account number",
        payerInfo: "Payer information",
        oprName: "Name of payer",
        contacts: "contacts",
        telephone: "contact number",
        invoiceType: "Invoice type",
        openInfo: "Billing information",
        companyName: "corporate name",
        taxId: "duty paragraph",
        payerBankAccountNo: "account number",
        registerAddress: "To address",
        no: "nothing",
    },
    // 新增提现单
    withdrawFormAdd: {
        pageAdd: "Add withdrawal form",
        pageUpdata: "Resubmit withdrawal form",
        invoiceType: "Invoice or not",
        totalAmount: "Withdrawal amount",
        availableAmount: "Withdrawal amount",
        allWithdraw: "Full withdrawal",
        minWithdraw: "Minimum withdrawal amount",
        serviceCharges: "Transfer fee",
        transferAmount: "Actual withdrawal amount",
        collectionInfo: "Collection info",
        bankAccountName: "title of account",
        bankDeposit: "Bank of deposit",
        bankAccountNo: "bank account",
        amountNullPl: "Please enter the withdrawal amount",
        amountErrorPl: "The withdrawal amount must be greater than 0 and no more than two decimal places",
        amountMin: "The one-time withdrawal amount cannot be less than",
        amountMax: "The one-time withdrawal amount shall not be less than 10, and the withdrawal amount shall not exceed the withdrawable amount",
    },
    // 头部
    header: {
        out: "Log out",
        outConfirm: "Are you sure you want to log out?",
        order: "Pending exception order",
        goClick: "Click to jump",
        unit: "",
        outTime: "Login expired, please login again",
    },
    //权限配置
    accessConfiguration: {
        roleName: "roleName",
        remark: "remark",
        createUserId: "createUserId",
        createTime: "createTime",
        updateTime: "updateTime",
        menuModule: "Menu Module",
        menuGlance: "Menu Glance",
        roleType: "Role Type",
        roleNameMsg: "Please enter the role Name",
        roleNameErrorMsg: "The role name cannot be more than 20 characters",
        roleTypeMsg: "Please select role type",
        jurisdiction: "Jurisdiction",
        operate: "Log",
        operationUserName: "Last operator",
        operationTime: "Last operation time",
        operationIp: "Last operation IP",
    },
    //用户管理
    userManage: {
        userName: "userName",
        role: "role",
        effectiveTime: "effectiveTime",
        status: "status",
        password: "password",
        confirmPassword: "Confirm Password",
        name: "name",
        addUser: "Add User",
        updateUser: "Update User",
        detailsUser: "Details User",
        userNameMsg: "Login account cannot be empty",
        roleMsg: "Role cannot be empty",
        passwordMsg: "Password cannot be empty",
        passwordLenMsg: "Please enter a password of 6 ~ 18 characters",
        passwordValMsg: "The password cannot contain spaces, tabs, and newlines",
        confirmPasswordMsg: "Confirm password cannot be empty",
        confirmPasswordOldMsg: "Confirm that the password is inconsistent with the password",
        effectiveTimeStartMsg: "The start time of the effective time must be filled in",
        effectiveTimeStartValMsg: "The start time cannot be greater than the end time",
        effectiveTimeEndMsg: "The end time of valid time must be filled in",
        effectiveTimeEndValMsg: "The end time cannot be less than the start time",
        assignedSite: "Assigned site",
        unassignedSite: "Unassigned site",
        moveLeft: "Move Left",
        moveRight: "Move Right",
        chargeStationName: "Charge Station Name",
        resetPassword: "reset password",
        fullName: "Name",
        operationUserName: "operator",
        operationTime: "operation time",
        operationIp: "operation IP",
        operationTypeName: "Operation type",
        content: "Operation content",
    },
    //发票管理
    invoiceInfo: {
        applicationTime: "Application time",
        globalSearch: "Order number/Phone number",
        invoiceType: "Invoice type",
        invoicingStatus: "Invoicing status",
        auditSettings: "Audit settings",
        invoiceOrderNumber: "Invoice order number",
        invoiceHeaderType: "Invoice title type",
        invoiceTitle: "Invoice title",
        taxNumber: "Tax number",
        invoiceAmount: "Invoice amount(RMB)",
        phoneNumber: "Phone number",
        invoicing: "Invoicing",
        invoiceUserName: "Invoicing User",
        issuer: "Issuer",
        processingMethod: "Processing method",
        courierCompany: "Courier company",
        shipmentNumber: "Shipment number",
        remark: "Remark",
        haveBeenMailed: "mail",
        noNeedToMail: "No need to mail",
        enterIssuer: "Please enter the billing person",
        selectMethod: "Please select the billing method",
        validationError: "Form validation error",
        selectAddress: "Please enter the mailing address",
        enterNumber: "Please enter the mailing order number",
        orderNumberLength: "The length of the mailing order number must not be less than eight digits",
        invoiceSuccessful: "Invoice successful",
        numberOfInvoices: "Number of invoices",
        electronicInvoice: "Electronic invoice",
        paperInvoice: "Paper invoice",
        totalInvoicedAmount: "Total invoice amount",
        invoicedServiceFee: "Invoiced service fee",
        invoicedElectricityBill: "Electricity billed",
        invoiceReviewProcess: "Invoice review process",
        on: "Turn on",
        close: "Turn off",
        selectionProcess: "Please select the invoice review process",
        setSuccessfully: "Set successfully",
        invoiceInformation: "Invoice Information",
        serviceCharge: "Service fee(RMB)",
        electricityBill: "Electricity fee(RMB)",
        eMail: "EMail",
        receivingInformation: "Receiving information",
        invoicingInformation: "Invoicing information",
        processingTime: "Processing time",
        invoiceSerialNumber: "Invoice serial number",
        payee: "Payee",
        reviewer: "Reviewer",
        unit: "Unit",
        invoicePicture: "Invoice picture",
        shippingAddress: "Shipping Address",
        denialReason: "Please enter the reason for rejection",
        orderNumber: "Order number",
        delayFee: "Delay fee(RMB)",
        discountedPrice: "Discount amount(RMB)",
        amountActuallyPaid: "Actual payment amount(RMB)",
        reviewCompleted: "Review completed",
        invoiceOperator: "Invoice operator",
        invoiceOrder: "Invoice Order",
        invoiceAuditRecord: "Audit records",
        operationTime: "Operation time",
        operationStatus: "Operation action",
        operation: "Operator",
        applyStatuse: "current state",
        confirmAudit: "Are you sure to approve?",
        operationSys: "System automatic processing",
        registerAddress: "registered address",
        registerTelephone: "registered Phone",
        bankDeposit: "Bank of deposit",
        bankAccountNo: "bank account",
        invoiceSettings: "Invoice Settings",
        hasOpenAudit: "Enable invoice review",
        invoiceTypePl: "Please select invoice type",
        hasOpenAuditPl: "Please choose whether to turn it on or not",
    },
    // 预约订单
    reserveChargingOrder: {
        durationRange: "Appointment duration",
        stopReason: "End Reason",
        startTime: "Appointment start time",
        handle: "handling",
        reservationOrderNo: "Reservation No",
        chargingTime: "Appointment of charging time",
        frozenAmount: "Frozen amount (yuan)",
        stopTime: "Appointment end time",
        actualDuration: "Actual appointment duration",
        transactionAmount: "Paid-in amount (yuan)",
        reasonType: "Reason for appeal",
        picture: "Site photos",
        auditResult: "Processing results",
        auditMind: "Handling opinions",
        reasonTitle: "Appointment Form Grievance Handling",
        auditMindPl: "Please input processing comments",
        auditResultPl: "Please select a processing result",
        totalOrder: "Total reservation",
        confirm: "After agreeing to the user's complaint, the frozen amount or paid amount of the charging reservation will be fully returned to the user's account. Do you want to continue?",
        reserveOrderStatus: "order status",
        reserveOrderTimeType: "Duration appointment form",
    },
    // 预约订单详情
    reserveChargingOrderOrder: {
        info: "Appointment Order Information",
        timingType1: "minute",
        timingType2: "Semih.",
        timingType: "Charge Type",
        freeMinutes: "Free duration (minutes)",
        timeoutDuration: "Operators can tolerate timeout duration(minutes)",
        total: "Total price (yuan)：",
        rate: "rate",
        slotFlag: "bucket type",
        time: "time slot",
        duration: "Duration (minutes)",
        feeInfo: "Billing information",
        orderInfo: "Order Information",
        orderStatus: "Order Status",
        chargingOrderNo: "Charging order number",
        life: "life cycle",
        operatingUserName: "Operator",
        occurTime: "Operation time",
        stopReason: "cause",
        imgList: "Auxiliary materials",
        refOrderNo: "Refund Order Number",
    },
    //子菜单标题
    childMenuTitle: {
        offCardOrderDetails: "Offline card order details",
        reserveChargingOrderDetails: "Appointment Order Details",
        chargeOrderDetail: "Order details",
        errorOrderDetail: "Exception details",
        abnormalOrder: "Abnormal processing",
        abnormalErrorOrder: "Abnormal processing ",
        // 发票管理
        invoiceDetails: "Invoice details",
        invoiceAudit: "Invoice review",
        permissionMune: "Permission configuration",
        siteMonitorDetails: "Monitoring details",
        // 桩
        pileUpdata: "Pile updata",
        pileUpdataRecord: "Pile updata record",
    },
    delayFeeManage: {
        acRate: "AC pile delay rate",
        dcRate: "DC pile delay rate",
        acRateDetails: "AC pile delay fee details",
        dcRateDetails: "DC pile delay fee details",
        dcDelayFeeUpperLimit: "Max DC delay fee",
        acDelayFeeUpperLimit: "Max AC delay fee",
        delayFeeUpperLimit: "Max delay fee",
    },
    chargeFeeManage: {
        acRateDetails: "Ac pile rate",
        dcRateDetails: "Dc pile rate",
    },
    //运营分析
    operateAnalysis: {
        chargeData: "Charging data",
        echartData: "Data Chart",
        totalChargePower: "Charging capacity",
        totalElecAmount: "electric charge",
        totalServiceAmount: "service charge",
        totalChargeTimes: "charging cycles",
        echartRadioCharge: "Charging capacity/charging cycles",
        echartRadioFee: "electric charge/service charge",
    },
    // 收入分析
    revenueAnalysis: {
        revenueTitle: "Total revenue and expenditure",
        totalIncomeAmount: "Total amount received",
        mchPayAmount: "Total expenditure amount",
        oprTotal: "Operator sharing",
        serviceCharges: "commission",
        mchIncomeAmount: "Revenue amount",
        picTitle: "Proportion of expenses",
        revenueEchartTitle: "Amount trend",
        feeYName: "Cost",
    },
    //充值管理
    memberRecharge: {
        rechargeOrderNum: "Number of recharge orders (transactions)",
        rechargeAmount: "Recharge amount(RMB)",
        rechargeTimes: "Number of recharges(times)",
        memberName: "Member name",
        cellphoneNumber: "Cellphone number",
        orderNumber: "Merchantor order number",
        rechargeMethod: "Recharge method",
        operatorCode: "Operator code",
        operatorName: "Operator name",
        memberNo: "Membership Number",
        memberPhoneNumber: "Member mobile number",
        merchantOrderNumber: "Merchant order number",
        paymentOrderNumber: "Payment order number",
        rechargeTime: "Recharge time",
        orderStatus: "Order Status",
        accountType: "Account type",
        accountNum: "Account number",
        rechargeInfo: "Recharge information",
        rechargeUserNum: "Number of recharge users",
    },
    //退款记录
    refundRecords: {
        pageTitle: "refund records",
        refundApplicationTime: "Refund application time",
        refundOrderQuantity: "Refund order quantity (items)",
        refundAmount: "Refund amount(RMB)",
        orderStatus: "Order Status",
        globalSearch: "Order number/Account number/Phone number",
        accountType: "Account type",
        refundMethod: "Refund method",
        pendingReview: "Pending review",
        rejected: "Rejected",
        returned: "Returned",
        paymentFailed: "Payment failed",
        nonPaymentNumber: "Unpaid",
        passed: "Passed",
        orderNumber: "Order number",
        accountNumber: "Account number",
        accountName: "Account name",
        phoneNumber: "Phone number",
        amountOfRefundRequested: "Amount of refund requested(RMB)",
        successfulRefundAmount: "Successful refund amount(RMB)",
        uploadCertificate: "Upload certificate",
        transferVoucher: "Transfer voucher",
        pleaseUploadAPicture: "Please upload a picture",
        successfulOperation: "Successful operation",
        refundReview: "Refund review",
        refundReviewPl: "Please select the refund review method",
        refundNoteText: "Refund note text",
        refundNoteTextPl: "Please enter the text description of the refund",
        autoText: "Refund authority",
        autoTextPl: "Please select the refund permission method",
        refundRecordDetails: "Refund record details",
        applicationInformation: "Application Information",
        processingInformation: "Processing information",
        reviewInformation: "Review information",
        refundOrderStatus: "Refund order status",
        remark: "Remark",
        refundDetails: "Refund details",
        refundFailed: "Refund failed",
        refundSuccessfully: "Refund successfully",
        agreeToARefund: "Agree to a refund",
        refusalToRefund: "Refusal to refund",
        enterReason: "Please enter the reason for rejecting the refund",
        processingTime: "Processing time",
        processingAction: "Processing action",
        processResult: "Process result",
        detailedOrderNumber: "Detailed order number",
        amount: "Amounts",
        refundTime: "Refund time",
        result: "Result",
        refundToUser: "Refund to user",
        refundErrResult: "reason",
        allAudit: "Batch audit",
        allAuditType: "Audit type",
        rejectRemark: "Reasons for refusal",
        auditUserName: "Handler",
        refundStatus: "Current state",
        refundType: "Refund Type",
        refundStatusName: "Refund status",
        noHandleData: "No processing information",
        paidRefundAmount: "Refund amount paid",
    },
};
